import React from 'react'
import "../nailcss/NailHomeSection.css";

function NailHomeSection() {
  return (
    <section className="nailhome-hero">

      <div className="nailhome-overlay"></div>

      <div className="nailhome-container">
        <div className="nailhome-content">

          <p className="nailhome-eyebrow">Nail Service At Your Home</p>

          <h1 className="nailhome-heading">
            Beautiful Nail Extensions &{" "}
            <span className="nailhome-heading-accent">Art</span> at Home
          </h1>

          <p className="nailhome-subtext">
            Choose your design, length and colour. Our trained female nail artist
            comes to your home with a clean, sanitised kit. Price is confirmed
            before the service starts.
          </p>

          <div className="nailhome-cta-row">
            <a href="#services" className="nailhome-btn nailhome-btn-primary">
              Book Service Now
            </a>
            <a
              href="https://wa.me/918527273020"
              target="_blank"
              rel="noopener noreferrer"
              className="nailhome-btn nailhome-btn-secondary"
            >
              Ask on WhatsApp
            </a>
          </div>

          <div className="nailhome-divider"></div>

          <div className="nailhome-trust-row">
            <div className="nailhome-trust-item">
              <span className="nailhome-trust-title">Delhi NCR</span>
              <span className="nailhome-trust-sub">Major areas covered</span>
            </div>
            <div className="nailhome-trust-item">
              <span className="nailhome-trust-title">Clean Kit</span>
              <span className="nailhome-trust-sub">Sanitised before use</span>
            </div>
            <div className="nailhome-trust-item">
              <span className="nailhome-trust-title">At Home</span>
              <span className="nailhome-trust-sub">No salon waiting</span>
            </div>
          </div>

        </div>
      </div>

      <div className="nailhome-price-badge">
        <span className="nailhome-price-icon">₹</span>
        <span className="nailhome-price-text">
          <span className="nailhome-price-label">Doorstep Service</span>
          <span className="nailhome-price-value">Starting from ₹799*</span>
        </span>
      </div>

    </section>
  )
}

export default NailHomeSection
